import Model from '../../ModelBinding/Model';
import MissionMediaOutputFormatAttributeCollection from './MissionMediaOutputFormatAttributeCollection';

export default class MissionMediaOutputFormatAttribute extends Model {
  public code?: string;
  public name?: string;
  public description?: string;
  public type?: string;
  public type_config?: string;
  public value?: string;
  static rootUri = 'mission-media/output-formats/attributes';
  
  bind() {
    this.code = this.getStringAttribute('code');
    this.name = this.getStringAttribute('name');
    this.description = this.getStringAttribute('description');
    this.type = this.getStringAttribute('type');
    this.value = this.getStringAttribute('value');
    this.type_config = this.getStringAttribute('type_config')
  }

  static getCollection() {
    return MissionMediaOutputFormatAttributeCollection;
  }
}
